import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { publicApi } from '../utils/api';
import { clientHandoffDestination } from '../utils/safeSameSitePath';

// Handoff landing (pkg15v2). Runs ON the firm subdomain. Reads ?token=,
// exchanges it for a real session JWT (server enforces firm-match + single-use
// + expiry), stores it under the per-firm key, and sends the user into the app.
// A client may also pass &next=. That path is used only when it is a same-site
// relative path; otherwise the client still lands on /.
export default function HandoffPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const next = params.get('next');
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) { setError('This sign-in link is missing its token.'); return; }
    publicApi.universalHandoff(token)
      .then((r) => {
        const sub = window.location.hostname.split('.')[0];
        try { localStorage.setItem(`lawmighty_token_${sub}`, r.token); } catch (_) { /* ignore */ }
        // Also write the legacy client token name so the existing client app
        // (which reads ryanlaw_token) picks up the session without changes.
        if (r.subjectType === 'client') {
          try { localStorage.setItem('ryanlaw_token', r.token); } catch (_) { /* ignore */ }
          window.location.href = clientHandoffDestination(next);
        } else {
          try { sessionStorage.setItem('ryanlaw_admin_token', r.token); } catch (_) { /* ignore */ }
          window.location.href = '/admin/dashboard';
        }
      })
      .catch((err) => setError(err.message || 'This sign-in link has expired or was already used.'));
  }, [token, next]);

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-brand"><h1>Signing you in…</h1></div>
        {!error ? (
          <p style={{ textAlign: 'center', color: '#888' }}><span className="spinner" /> One moment…</p>
        ) : (
          <>
            <div className="alert alert-error">{error}</div>
            <a className="btn btn-primary btn-block" href="/admin">Back to sign in</a>
          </>
        )}
      </div>
    </div>
  );
}
